
/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'mobx-react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function(
	React,
	MobxReact,
	UI_TOOLKIT,
	PropTypes
) {
/**
 * @class HintText
 * @description Creates a property control of type static text for a hint text.
 * @example
 * {
 * 		item: {
 *			editor: {
 *				uiControl: {
 *					label: 'This is the hint text' // required field
 *				}
 *			}
 *		}
 *		className: 'property--controls property--controls--HintText'
 * }
 */

	class HintText extends React.Component {

		_getUiControl() {
			return this.props.item && this.props.item.editor && this.props.item.editor.uiControl;
		}

		render() {
			const { label } = this._getUiControl();
			const containerProps = {
				className: this.props.className
			};
			return (
				<div {...containerProps}>
					<UI_TOOLKIT.Label
						label={label}
					/>
				</div>
			);
		}
	}

	HintText.propTypes = {
		item: PropTypes.shape({
			editor: PropTypes.shape({
				uiControl: PropTypes.shape({
					label: PropTypes.string.isRequired
				}).isRequired
			}).isRequired,
		}).isRequired,
		className: PropTypes.string
	};
	HintText.defaultProps = {};

	return MobxReact.observer(HintText);
});
